import { StyleSheet } from 'react-native';

import { Theme } from '@constants';

export const styles = StyleSheet.create({
  modalContent: {
    bottom: Theme.px(0),
    height: Theme.px(625),
    position: 'absolute',
    width: Theme.px(1920),
  },
});
